import { User } from "./User";

export enum ActionType {
    Create,
    Update,
    Delete,
    Login,
    Logout
}

export class Log {
    idlog: number;
    user: User;
    createdAt: Date;
    action: ActionType;
    objectID: string;
    objectType: string;
    objectName: string;
    before: Record<string, any> | null;
    after: Record<string, any> | null;

    constructor() {
        this.idlog = 0;
        this.user = new User();
        this.createdAt = new Date();
        this.action = ActionType.Create;
        this.objectID = '';
        this.objectType = '';
        this.objectName = '';
        this.before = null;
        this.after = null;
    }

}

